import React from "react";
import { connect } from "react-redux";
import { RouteComponentProps } from "react-router";

import { bindActionCreators } from "redux";

import { Overlay } from "@plex/react-components";

import { INotification } from "infrastructure/notification";
import { Banner } from "ui/app";

import { SecurityRoleMembersFilter, SecurityRoleMembersGrid, SecurityRoleMembersActionBar } from "./components";
import { securityRoleMembersActions } from "./SecurityRoleMembers.actions";
import { ISecurityRoleMembersState, ISecurityRoleMember, ISecurityRoleMembersFilter } from "./SecurityRoleMembers.state";

export interface ISecurityRoleMembersProps {
  filter?: ISecurityRoleMembersFilter;
  items?: ISecurityRoleMember[];
  selectedItems: ISecurityRoleMember[];
  notifications: INotification[];
  isLoading: boolean;
  loadSecurityRoleMembers: () => void;
  onSelectionChanged: (rows: ISecurityRoleMember[]) => void;
  revokeSecurityRole: (rows: ISecurityRoleMember[]) => void;
}

export const SecurityRoleMembers: React.FC<ISecurityRoleMembersProps & RouteComponentProps> = ({
  items,
  filter,
  location,
  notifications,
  selectedItems,
  isLoading,
  onSelectionChanged,
  revokeSecurityRole
}) => {
  const params = new URLSearchParams(location.search);

  return (
    <>
      <Overlay show={isLoading} showSpinner />
      <Banner messages={notifications} />
      <SecurityRoleMembersFilter selectedSecurityRoleId={params.get("roleId")} selectedTenantId={params.get("tenantId")} />
      <SecurityRoleMembersActionBar selectedMembers={selectedItems} securityRoleMembersFilter={filter} revokeSecurityRole={revokeSecurityRole} />
      <SecurityRoleMembersGrid items={items} onSelectionChanged={onSelectionChanged} selectedItems={selectedItems} />
    </>
  );
};

export default connect(
  (state: { securityRoleMembers: ISecurityRoleMembersState }) => {
    return {
      filter: state.securityRoleMembers.filter,
      items: state.securityRoleMembers.items,
      notifications: state.securityRoleMembers.notifications.filter(n => !n.areaName),
      isLoading: state.securityRoleMembers.isLoading,
      selectedItems: state.securityRoleMembers.selectedItems
    };
  },
  dispatch => {
    return bindActionCreators(
      {
        onSelectionChanged: securityRoleMembersActions.onSelectionChanged,
        revokeSecurityRole: securityRoleMembersActions.revokeSecurityRole
      },
      dispatch
    );
  }
)(SecurityRoleMembers);
